import axios from 'axios'
import config from '../config'

const Bundle = {
    state: {
        error: false,
        msg: ''
    },
    mutations:{
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
       async AddBundle({commit}, data){
           await axios({
               method:'post',
               url: config.ADD_BUNDLE,
               data: data
           })
           .then((result) => {
               commit('ERROR', result.data.error)
               commit('MSG', result.data.msg)
           }).catch((err) => {
               console.log(err)
           });
       },
       async bundleUpdate({commit}, data){
           await axios({
               method:'post',
               url: config.BUNDLE_UPDATE,
               data: data
           })
           .then((result) => {
               commit('ERROR', result.data.error)
               commit('MSG', result.data.msg)
           }).catch((err) => {
               console.log(err);
           });
       },
       async bundleUpdateStatus({commit}, data){
           await axios({
               method:'post',
               url: config.BUNDLE_UPDATE_STATUS,
               data: data
           })
           .then((result) => {
               commit('ERROR', result.data.error)
               commit('MSG', result.data.msg)
           }).catch((err) => {
               console.log(err)
           });
       }
    },
    getters: {
        getBundleError: state => state.error,
        getBundleMsg: state => state.msg
    },
}

export default Bundle;